import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface DataZonesRequestsTableProps {
    dataZones: any[];
    resourceStatuses: any[];
}

const DataZonesRequestsTable: React.FC<DataZonesRequestsTableProps> = ({
    dataZones,
    resourceStatuses
}: DataZonesRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2.5}><Typography fontSize="12px">DATA ZONE NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">LAKE NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">ZONE TYPE</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={2}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {dataZones.map((dataZone: any, index: number) => (
                <ListItem
                    key={dataZone.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: dataZone.status === "active" || dataZone.status === "approved" ? "#FFFFFF" : dataZone.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/datasolutions/requests/data-zones/${dataZone.id}`);
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: dataZone.status === "active" || dataZone.status === "approved" ? "#12B76A" : dataZone.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: dataZone.status === "active" || dataZone.status === "approved" ? "#12B76A" : dataZone.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{dataZone.zoneName}</Typography>
                                    {(dataZone.status === 'active' || dataZone.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                        <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${dataZone.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === dataZone.id).map((e: any, i: number) => ( <React.Fragment key={`${dataZone.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                            <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataZone.lakeName || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataZone.zoneType || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={dataZone.zoneOwnerAvatar} alt={dataZone.zoneOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataZone.zoneOwnerName ? dataZone.zoneOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataZone.zoneOwnerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataZone.createdAt ? moment(dataZone.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {dataZone.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {dataZone.zoneApproverName &&
                                            <Avatar src={dataZone.zoneApproverAvatar} alt={dataZone.zoneApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataZone.zoneApproverName.charAt(0).toUpperCase()}</Avatar>
                                        }
                                        {dataZone.zoneApproverName &&
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{dataZone.zoneApproverName}</Typography>
                                        }
                                        {dataZone.status === "rejected" && dataZone.reasonForRejection && (
                                            <Tooltip title={`Reason: ${dataZone.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1.5}>
                                {(dataZone.status !== "pending" && dataZone.actionedAt) && (
                                    <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(dataZone.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default DataZonesRequestsTable;